import {
  textStyleSizeOptions,
  textStyleWeightOptions,
  textStyleSizeStyleOptions,
  textStyleWeightStyleOptions
} from '../../fundamentals/text-styles/constants'

export const contextMenuPaddingOptions = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  'EXTRA-LARGE': 'extra-large'
}

export const contextMenuControlOptions = {
  RADIO: 'radio',
  CHECKBOX: 'checkbox'
}

export const contextMenuSizeOptions = {
  DESKTOP: 'desktop',
  MOBILE: 'mobile'
}

export const contextMenuSideOptions = {
  TOP: 'top',
  RIGHT: 'right',
  BOTTOM: 'bottom',
  LEFT: 'left'
}

export const contextMenuAlignOptions = {
  START: 'start',
  CENTER: 'center',
  END: 'end'
}

export const contextMenuArrowAlignmentOptions = {
  START: 'start',
  CENTER: 'center',
  END: 'end'
}

export const contextMenuTitleSizeOptions = {
  'TEXT-R': textStyleSizeOptions['TEXT-R'],
  'TEXT-L': textStyleSizeOptions['TEXT-L'],
  'TEXT-XL': textStyleSizeOptions['TEXT-XL']
}

export const contextMenuVariantOptions = {
  STANDARD: 'standard',
  DESTRUCTIVE: 'destructive',
  RESTRICTED: 'restricted'
}

export const contextMenuTitleWeightOptions = {
  'TEXT-500': textStyleWeightOptions['TEXT-500'],
  'TEXT-600': textStyleWeightOptions['TEXT-600'],
  'TEXT-700': textStyleWeightOptions['TEXT-700']
}

export const contextMenuSize = {
  [contextMenuSizeOptions.DESKTOP]: '34px',
  [contextMenuSizeOptions.MOBILE]: '40px'
}

export const contextMenuPadding = {
  [contextMenuPaddingOptions.SMALL]: '0.125rem 0.125rem',
  [contextMenuPaddingOptions.MEDIUM]: '0.125rem 0.25rem',
  [contextMenuPaddingOptions.LARGE]: '0.125rem 0.5rem',
  [contextMenuPaddingOptions['EXTRA-LARGE']]: '0.5rem'
}

export const contextMenuTitleSize = {
  [contextMenuTitleSizeOptions['TEXT-R']]:
    textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']],
  [contextMenuTitleSizeOptions['TEXT-L']]:
    textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-L']],
  [contextMenuTitleSizeOptions['TEXT-XL']]:
    textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-XL']]
}

export const contextMenuTitleWeight = {
  [contextMenuTitleWeightOptions['TEXT-600']]:
    textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']],
  [contextMenuTitleWeightOptions['TEXT-700']]:
    textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-700']]
}

export const skeletonLoading = {
  initial: { backgroundColor: 'hsl(240, 11%, 85%)' },
  animate: { backgroundColor: 'hsl(240, 11%, 95%)' },
  transition: {
    duration: 1,
    ease: 'linear',
    repeat: Infinity,
    repeatType: 'reverse'
  }
}
